import * as React from 'react';

import { UitkHeading } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';

import { ActivityDestinationViewSearch } from '../../../common/__generated__/api';

import { useStores } from '../../../utils/hooks';

import { ActivityKeywordSearchInput } from '../../common/activity-keyword-search-input';
import { Checkbox } from './checkbox';
import { Radio } from './radio';

export interface FilterProps {
  inDialog?: boolean;
}

export const Filter: React.FC<FilterProps> = ({ inDialog }) => {
  const { activitySearchStore } = useStores();
  const filterSections = activitySearchStore.universalSortAndFilter?.filterSections;

  if (!filterSections) {
    return <></>;
  }

  const getTestID = (field: ActivityDestinationViewSearch.__Fields): any => {
    let testId = '';
    if (field.__typename === 'ShoppingTextInputField') {
      testId = field.id;
    } else if (field.__typename === 'ShoppingMultiSelectionField' || field.__typename === 'ShoppingSelectionField') {
      testId = field.options ? field.options[0]?.id : testId;
    }

    return testId;
  };

  const sortAndFilterFields = (field: ActivityDestinationViewSearch.__Fields): JSX.Element => {
    switch (field.__typename) {
      case 'ShoppingTextInputField':
        return <ActivityKeywordSearchInput inDialog={inDialog} />;
      case 'ShoppingSelectionField':
        return (
          <Radio
            inDialog={inDialog}
            field={field as ActivityDestinationViewSearch.ShoppingSelectionFieldInlineFragment}
          />
        );
      case 'ShoppingMultiSelectionField':
        return (
          <Checkbox
            inDialog={inDialog}
            field={field as ActivityDestinationViewSearch.ShoppingMultiSelectionFieldInlineFragment}
          />
        );
      default:
        return <></>;
    }
  };

  return (
    <>
      {filterSections.map((filterSection: ActivityDestinationViewSearch.FilterSections, index: number) => (
        <UitkSpacing key={index} margin={{ blockend: 'four' }} padding={{ blockend: 'four' }}>
          <section className="uitk-card-separator-bottom">
            {filterSection.title && (
              <UitkSpacing padding={{ blockend: 'two' }}>
                <UitkHeading tag="h2" size={5} data-testid="filter-section--header">
                  {filterSection.title}
                </UitkHeading>
              </UitkSpacing>
            )}
            {filterSection?.fields.map((field: ActivityDestinationViewSearch.__Fields, i: number) => (
              <div key={`${getTestID(field)}-${i}`} data-testid={`sort-filter-${getTestID(field)}-field`}>
                {sortAndFilterFields(field)}
              </div>
            ))}
          </section>
        </UitkSpacing>
      ))}
    </>
  );
};
